export const REVIEW_PAGE_SIZES = [10, 20, 50, 100];

export const REVIEW_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "rating_desc", label: "Rating: high to low" },
  { value: "rating_asc", label: "Rating: low to high" },
  { value: "product_asc", label: "Product: A–Z" },
];

function getSearchHaystack(review) {
  const productName =
    typeof review.product === "object" && review.product
      ? review.product.name
      : "";
  return [
    review.name,
    review.email,
    review.comment,
    productName,
    review.rating,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

function compareReviews(a, b, sortBy) {
  switch (sortBy) {
    case "oldest":
      return new Date(a.createdAt) - new Date(b.createdAt);
    case "rating_desc":
      return (b.rating || 0) - (a.rating || 0);
    case "rating_asc":
      return (a.rating || 0) - (b.rating || 0);
    case "product_asc": {
      const nameA =
        typeof a.product === "object" && a.product ? a.product.name || "" : "";
      const nameB =
        typeof b.product === "object" && b.product ? b.product.name || "" : "";
      return nameA.localeCompare(nameB, undefined, { sensitivity: "base" });
    }
    case "newest":
    default:
      return new Date(b.createdAt) - new Date(a.createdAt);
  }
}

export function filterAndSortReviews(reviews, filters) {
  const {
    search = "",
    rating = "all",
    approval = "all",
    dateFrom = "",
    dateTo = "",
    sortBy = "newest",
  } = filters;

  const query = search.trim().toLowerCase();
  const fromTime = dateFrom ? new Date(`${dateFrom}T00:00:00`).getTime() : null;
  const toTime = dateTo ? new Date(`${dateTo}T23:59:59.999`).getTime() : null;
  const ratingNum = rating === "all" ? null : Number(rating);

  const filtered = (reviews || []).filter((review) => {
    if (ratingNum != null && review.rating !== ratingNum) return false;

    if (approval === "approved" && !review.isApproved) return false;
    if (approval === "hidden" && review.isApproved) return false;

    if (fromTime || toTime) {
      const created = new Date(review.createdAt).getTime();
      if (fromTime && created < fromTime) return false;
      if (toTime && created > toTime) return false;
    }

    if (query && !getSearchHaystack(review).includes(query)) return false;
    return true;
  });

  return [...filtered].sort((a, b) => compareReviews(a, b, sortBy));
}
